
namespace Gamification.Gamification {

    export interface UtentiProdottiEsperienzeListGridOptions {
        IdUtenteProdotto: number,
        IdProdottoEsperienza: number,
        IdProdottoEsperienzaNome: string
    }

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeListGrid extends Serenity.EntityGrid<UtentiProdottiEsperienzeRow, any> {
        protected getColumnsKey() { return UtentiProdottiEsperienzeColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiEsperienzeDialog; }
        protected getIdProperty() { return UtentiProdottiEsperienzeRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeService.baseUrl; }

        constructor(container: JQuery, options: UtentiProdottiEsperienzeListGridOptions) {
            super(container, options);

            this.setTitle("Sessioni dell'esperienza " + options.IdProdottoEsperienzaNome);
        }

        protected createQuickSearchInput() { }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Esperienze',
                name: '',
                format: ctx => '<a class="inline-action goto-esperienze" title="Elenco task dell\'esperienza">' +
                    '<i class="fa fa-tasks text-green"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('goto-esperienze')) {
                    var theDialog = new Gamification.UtentiProdottiEsperienzeTaskListGridDialog({
                        IdUtenteProdottoEsperienza: item.IdUtenteProdottoEsperienza,
                        IdProdottoEsperienzaNome: item.IdProdottoEsperienzaNome,
                        DataOraInizio: item.DataOraInizio
                    });
                    theDialog.dialogOpen();
                }
            }
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            request.Criteria = Serenity.Criteria.and([[Gamification.UtentiProdottiEsperienzeRow.Fields.IdUtenteProdotto], '=', this.options.IdUtenteProdotto], request.Criteria);
            request.Criteria = Serenity.Criteria.and([[Gamification.UtentiProdottiEsperienzeRow.Fields.IdProdottoEsperienza], '=', this.options.IdProdottoEsperienza], request.Criteria);

            return true;
        }
    }
}